module.exports = __webpack_public_path__ + "zvetseni-prsou_11_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_11_after.jpg
// module id = 1295
// module chunks = 0